import { get, writable } from "svelte/store";
export class WritableSet {
    constructor() {
        this.setStore = writable(new Set());
    }
    add(value) {
        const set = get(this.setStore);
        set.add(value);
        this.size = set.size;
        this.setStore.set(set);
        return this;
    }
    clear() {
        const set = get(this.setStore);
        set.clear();
        this.size = set.size;
        this.setStore.set(set);
    }
    delete(value) {
        const set = get(this.setStore);
        const deleted = set.delete(value);
        this.size = set.size;
        this.setStore.set(set);
        return deleted;
    }
    toggle(value) {
        const set = get(this.setStore);
        if (set.has(value)) {
            set.delete(value);
        }
        else {
            set.add(value);
        }
        this.size = set.size;
        this.setStore.set(set);
    }
    forEach(callbackfn, thisArg) {
        get(this.setStore).forEach(callbackfn, thisArg);
    }
    has(value) {
        return get(this.setStore).has(value);
    }
    entries() {
        return get(this.setStore).entries();
    }
    keys() {
        return get(this.setStore).keys();
    }
    values() {
        return get(this.setStore).values();
    }
    [Symbol.iterator]() {
        throw new Error("Method not implemented.");
    }
    subscribe(run, invalidate) {
        return this.setStore.subscribe(run, invalidate);
    }
}
Symbol.toStringTag;
